import { render } from "./CliniqueindexComponent.vue?vue&type=template&id=c82d61fa"
import script from "./CliniqueindexComponent.vue?vue&type=script&lang=js"
export * from "./CliniqueindexComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__